import { FC } from 'react';

import { BlogTagDto } from '@/components/BlogPage/types';

import css from './style.module.scss';

interface Props {
	tags: BlogTagDto[];
	className?: string;
}

const InlineTags: FC<Props> = ({ tags, className }) => (
	<p className={className}>
		{tags?.map((tag, index) => (
			<span key={tag.id} className={css.inlineTag}>
				{tag.name}
				{index < tags.length - 1 && ','}
			</span>
		))}
	</p>
);

export default InlineTags;
